import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["StaticFooter"] */ "/vercel/path0/src/app/(static)/static-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaticNavigation"] */ "/vercel/path0/src/app/(static)/static-navigation.tsx");
